const dms_style = {
    table_row: {
        cursor: "pointer"
    }
}

export { dms_style };